import * as XLSX from "xlsx";

type Row = Record<string, any>;

export const autoFitColumns = (
  worksheet: XLSX.WorkSheet,
  rows: Row[],
  minWidth = 10,
  padding = 2
) => {
  if (!rows.length) {
    worksheet["!cols"] = [];
    return;
  }

  const keys = Object.keys(rows[0]);

  const colWidths = keys.map((key) => {
    let maxLength = key.length;

    for (const row of rows) {
      const value = row[key];
      const length =
        value === null || value === undefined
          ? 0
          : String(value).length;

      maxLength = Math.max(maxLength, length);
    }

    return {
      wch: Math.max(minWidth, maxLength) + padding,
    };
  });

  worksheet["!cols"] = colWidths;
};
